mutation CorporateWorkgroupDelete($input: CorporateWorkgroupDeleteInput!) {
  corporateWorkgroupDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
